import React from "react";

import styled from "@emotion/styled";

import { COLORS } from "shared/config/constants";
import { BankWarning, ErrorTriangleIcon } from "shared/icons";
import {
  PMS_APPROVED_LABEL,
  VERO_NOT_COMPLETED_LABEL,
} from "shared/utils/deal-status";
import { formatDate } from "shared/utils/ui";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
`;

const Pill = styled.span<{ background: string; color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  background: ${({ background }) => background};
  color: ${({ color }) => color};

  svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

const SubText = styled.span`
  font-size: 12px;
  color: ${COLORS.disabledText};
  white-space: nowrap;
`;

const NO_VERO_SUBMISSION_TEXT = "No VERO submission";

export interface PmsApprovedNoVeroBannerProps {
  approvedAt?: string;
}

export const PmsApprovedNoVeroBanner = ({
  approvedAt,
}: PmsApprovedNoVeroBannerProps) => {
  const formattedApprovedAt = approvedAt ? formatDate(approvedAt) : null;
  const subText = formattedApprovedAt
    ? `Yardi approval received ${formattedApprovedAt} \u00b7 ${NO_VERO_SUBMISSION_TEXT}`
    : NO_VERO_SUBMISSION_TEXT;

  return (
    <Container data-testid="pms-approved-no-vero-banner">
      <Pill background={COLORS.tag.orange.background} color={COLORS.primary}>
        <BankWarning />
        {PMS_APPROVED_LABEL}
      </Pill>
      <Pill background={COLORS.tag.red.background} color={COLORS.red}>
        <ErrorTriangleIcon />
        {VERO_NOT_COMPLETED_LABEL}
      </Pill>
      <SubText>{subText}</SubText>
    </Container>
  );
};
